module.exports = __webpack_public_path__ + "img/stock1.815f0a2c.png";